import { useGlobalTokenLang } from "../core/hooks/useGlobalTokenLang";

const TokenLangHandler = () => {
  useGlobalTokenLang();
  return null;
};

export default TokenLangHandler;
